<template>
  <div>
    <p>
      We have the ability to produce unique products that fit your specific needs and desired project results.
    </p>
    <carousel item="architectural-elements" :images="images"></carousel>
  </div>
</template>

<script>
  import Carousel from '@/components/Carousel'

  export default {
    name: "ArchitecturalElements",
    components: {Carousel},
    data() {
      return {
        images: [
          'architectural-elements-0.jpeg',
          'architectural-elements-1.jpeg',
          'architectural-elements-2.jpeg',
          'architectural-elements-3.jpeg',
        ]
      }
    }
  }
</script>

<style scoped>

</style>